var render, staticRenderFns
import script from "./Endpoints.vue?vue&type=script&lang=js&"
export * from "./Endpoints.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/build/repo/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('dcd2bd6c')) {
      api.createRecord('dcd2bd6c', component.options)
    } else {
      api.reload('dcd2bd6c', component.options)
    }
    
  }
}
component.options.__file = "src/components/common/Endpoints.vue"
export default component.exports